"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var UserDeckStore = /*#__PURE__*/function (_RootStore) {
  function UserDeckStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, UserDeckStore);
    _this = _callSuper(this, UserDeckStore);
    _this.config = {
      model: _models.UserDeck,
      deserialize: true,
      GET: {
        index: '/user_decks',
        show: '/user_decks/:userDeckId'
      },
      PUT: {
        update: '/user_decks/:userDeckId'
      },
      POST: {
        create: '/user_decks',
        reset: '/user_decks/:userDeckId/reset'
      },
      DELETE: {
        destroy: '/user_decks/:userDeckId'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(UserDeckStore, _RootStore);
  return (0, _createClass2["default"])(UserDeckStore, [{
    key: "onReset",
    value: function onReset(params, callback) {
      this.api(params, callback || this.getShow.bind(this), 'POST', 'reset');
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new UserDeckStore();